/*****************************************************
Naam: DashboardTopButtons.jsx
Locatie: src/components/Dashboard/DashboardTopButtons.jsx
Datum: 2026-02-07
Versie: 1.0.0
******************************************************
Beschrijving:
Top buttons: Status Aanvragen, Email Aanvragen.
******************************************************/

import React from 'react';
import { List, Mail, MessageSquare } from 'lucide-react';

const DashboardTopButtons = ({ 
  emailQueueLength,
  totaalAanvragenCount,
  getButtonStyle, 
  onOpenStatus, 
  onOpenEmailQueue, 
}) => {
  return (
    <>
      {/* Status Aanvragen knop - midden bovenaan */}
      <div className="absolute top-6 left-1/2 transform -translate-x-1/2">
        <button
          onClick={onOpenStatus}
          className="relative text-white px-10 py-4 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 w-64"
          style={getButtonStyle('statusAanvragen')}
        >
          {totaalAanvragenCount > 0 && (
            <span className="absolute -top-2 -right-2 bg-white text-blue-900 text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center border-2 border-blue-900 shadow">
              {totaalAanvragenCount > 99 ? '99+' : totaalAanvragenCount}
            </span>
          )}
          <div className="flex items-center gap-3">
            <List className="w-7 h-7" />
            <div>
              <div className="text-base font-bold">Status Aanvragen</div>
              <div className="text-xs opacity-80">Overzicht en filters</div>
            </div>
          </div>
        </button>
      </div>

      {/* Email Aanvragen knop */}
      <div className="absolute top-28 left-1/2 transform -translate-x-1/2">
        <button
          onClick={onOpenEmailQueue}
          className="relative px-10 py-4 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 text-white w-64"
          style={emailQueueLength > 0 
            ? { backgroundColor: '#ef4444', boxShadow: '0 8px 20px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.2)' }
            : getButtonStyle('emailAanvragen')
          }
        >
          <div className="flex items-center gap-3">
            <Mail className="w-7 h-7" />
            <div>
              <div className="text-base font-bold">Email Aanvragen</div>
              <div className="text-xs opacity-80">
                {emailQueueLength > 0 
                  ? `${emailQueueLength} ${emailQueueLength === 1 ? 'aanvraag' : 'aanvragen'} te verwerken`
                  : 'Geen nieuwe aanvragen'
                }
              </div>
            </div>
          </div>
          {emailQueueLength > 0 && (
            <div className="absolute -top-2 -right-2 bg-white text-red-600 rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm shadow-lg animate-pulse border-2 border-red-600">
              {emailQueueLength}
            </div>
          )}
        </button>
      </div>
      

    </>
  );
};

export default DashboardTopButtons;
